export enum DatePeriodType {
  Hour = 'Hour',
  Day = 'Day',
  Month = 'Month'
}
